import React, { useState } from 'react';
import api from '../api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.login(username, password);
      onLogin(res);
    } catch {
      setError('Hibás felhasználónév vagy jelszó');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.logo}>🗺️ AI TourMate</div>
        <h2 style={styles.title}>Dashboard</h2>
        {error && <div style={styles.error}>{error}</div>}
        <input style={styles.input} placeholder="Felhasználónév" value={username} onChange={e => setUsername(e.target.value)} autoFocus />
        <input style={styles.input} type="password" placeholder="Jelszó" value={password} onChange={e => setPassword(e.target.value)} />
        <button className="btn" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
          {loading ? 'Belépés...' : 'Belépés'}
        </button>
      </form>
    </div>
  );
}

const styles = {
  wrapper: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0f1117' },
  form: { background: '#1a1d27', border: '1px solid #2a2e3a', borderRadius: 16, padding: 40, width: 360, display: 'flex', flexDirection: 'column', gap: 12 },
  logo: { fontSize: 32, textAlign: 'center', marginBottom: 4 },
  title: { textAlign: 'center', color: '#00d4ff', fontWeight: 600, fontSize: 18, marginBottom: 8 },
  error: { background: 'rgba(248,113,113,0.15)', color: '#f87171', padding: '8px 12px', borderRadius: 8, fontSize: 13, textAlign: 'center' },
  input: { background: '#0f1117', border: '1px solid #2a2e3a', color: '#e4e6eb', padding: '10px 14px', borderRadius: 8, fontSize: 14 },
};
